import type { NavGroup } from '@time-line/components/types';
import { useRouter } from 'next/router';
import { useEffectOnce } from 'react-use';

export const usePrefetchNavigation = (
  primary?: NavGroup,
  secondary?: NavGroup[],
) => {
  const router = useRouter();

  useEffectOnce(() => {
    if (!primary) return;

    [primary, ...(secondary || [])].forEach(({ subNav }) => {
      subNav.items.forEach((navItem) => {
        if (!navItem.href) return;
        router.prefetch(navItem.href);
      });
    });
  });
};
